import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { empty } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SpinnerService } from 'src/app/core/spinner.service';

import { ProfileService } from './profile.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileMetadataResolver implements Resolve<any> {
  constructor(private profileService: ProfileService, private spinnerService: SpinnerService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.spinnerService.show(' Loading profile metadata. Please wait..');
    return this.profileService.getProfileMetaData().pipe(
      catchError((error) => {
        console.log('error fetching profile metadata ' + error);
        return empty();
      }),
    );
  }
}
